export const POINT_OF_SALE_ACTIVE_TTL_ES = 'Puntos de Ventas Activos';
export interface IPointOfSaleActiveBase {
  branchStoreId: number;
  code: string;
  seriesOfReceipts: number;
}
export interface IPointOfSaleActive extends IPointOfSaleActiveBase {
  id: number;
}
